var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.85714 8.41555C0.931932 3.45678 6.61628 -1.14333 12 5.33071C17.3837 -1.14333 23.0681 3.45647 23.1429 8.41526C23.1429 15.7975 14.1304 21.8571 12 21.8571C9.8696 21.8571 0.85714 15.7978 0.85714 8.41555Z",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarExperience);
export default __webpack_public_path__ + "static/media/sidebar_experience.f817361d9ccefde8474b0ac4bdfdafdb.svg";
export { ForwardRef as ReactComponent };